// extracted by mini-css-extract-plugin
export default {"addToCartControl":"O0-z","giftCard":"P0-z","btnContainer":"Q0-z","cartButton":"R0-z","disabled":"S0-z"};